import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const siteCatalogSyncRoutes = [
    {
        path: '/Settings/SiteCatalogSync',
        component: React.lazy(() => import('./SiteCatalogSyncPage')),
        auth: authRoles.admin,
        accessPageName: 'SETTINGS',
    },
]

export default siteCatalogSyncRoutes
